import {z} from 'zod'

const equipmentUtilizationRawSchema = z.object({
    rental_asset_type_id: z.string(),
    type_name: z.string(),
    total: z.number(),
    utilized: z.number(),
    available: z.number(),
})

export const equipmentUtilizationSchema = equipmentUtilizationRawSchema.transform((raw) => ({
    rentalAssetTypeId: raw.rental_asset_type_id,
    typeName: raw.type_name,
    total: raw.total,
    utilized: raw.utilized,
    available: raw.available,
}))

export type EquipmentUtilizationRaw = z.infer<typeof equipmentUtilizationRawSchema>
export type EquipmentUtilization = z.infer<typeof equipmentUtilizationSchema>

const workerUtilizationRawSchema = z.object({
    worker_type_id: z.string(),
    type_name: z.string(),
    total: z.number(),
    on_jobs: z.number(),
})

export const workerUtilizationSchema = workerUtilizationRawSchema.transform((raw) => ({
    workerTypeId: raw.worker_type_id,
    typeName: raw.type_name,
    total: raw.total,
    onJobs: raw.on_jobs,
}))

export type WorkerUtilizationRaw = z.infer<typeof workerUtilizationRawSchema>
export type WorkerUtilization = z.infer<typeof workerUtilizationSchema>

const fleetUtilizationRawSchema = z.object({
    equipment: z.array(equipmentUtilizationRawSchema),
    workers: z.array(workerUtilizationRawSchema),
})

export const fleetUtilizationSchema = fleetUtilizationRawSchema.transform((raw) => ({
    equipment: raw.equipment.map((entry) => equipmentUtilizationSchema.parse(entry)),
    workers: raw.workers.map((entry) => workerUtilizationSchema.parse(entry)),
}))

export type FleetUtilizationRaw = z.infer<typeof fleetUtilizationRawSchema>
export type FleetUtilization = z.infer<typeof fleetUtilizationSchema>
